var search = {};

(function (searchApp) {
	var filterModel = {
		SearchTerm: "",
		ProductPage: 1,
		ArticlePage: 1
	};

	searchApp.GetSearchResults = function () {
		$.ajax({
			url: "/umbraco/surface/GransRemedySearchSurface/GetFilterResult",
			type: "GET",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-search-results").html(data);
				$(".js-search-results").show();
				searchApp.setInputValue();
			},
			error: function (xhr, status, error) {
				console.log(status);
				console.log(xhr.status + " - " + error);
			}
		});
	};

	searchApp.setInputValue = function () {
		$(".js-search-field").val(filterModel.SearchTerm);
	};

	$(document).ready(function () {
		let timer;

		$(".js-search-field")
		.on("keyup change", function(event) {
			if(event.which !== 13) {
				debounce(searchFromField, 500).call(this, event);
			}
		});

		function debounce(func, timeout = 300){
			return (...args) => {
				clearTimeout(timer);
				timer = setTimeout(() => { func.apply(this, args); }, timeout);
			};
		}

		function searchFromField($event) {

			var searchValue = $event.target.value;
			if (searchValue.length >= 3) {
				filterModel.SearchTerm = searchValue;
				searchApp.GetSearchResults();
			} else {
				$(".js-search-results").hide();
			}
		}

		$(".js-popular-search-link").on('click', function (e) {
			e.preventDefault();
			filterModel.SearchTerm = $(this).data("popsearch");
			searchApp.GetSearchResults();
		});
	});

})(search);
